define('views/base/list_page_view',['require','backbone','marionette'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    return Backbone.Marionette.LayoutView.extend({

        setCollection: function () {
            // To be overridden
        },

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
            this.setCollection();

            var _this = this;
            var urlParameters = App.utils.getUrlParameters();
            urlParameters.forEach(function (parameterData) {
               if (parameterData.key == 'search') {
                   if (parameterData.value) {
                       _this.collection.changeSearchQuery(parameterData.value);
                   }
               } else if (parameterData.key == 'ordering') {
                   if (parameterData.value) {
                       _this.collection.changeOrdering(parameterData.value);
                   }
               } else if (parameterData.key == 'page') {
                   if (parameterData.value) {
                       _this.collection.changePage(parameterData.value);
                   }
               } else {
                   // Filter parameter
                   if (parameterData.value) {
                       _this.collection.changeFilter(parameterData.key, parameterData.value);
                   }
               }
            });

            this.listenTo(this.collection, 'fetch_complete', this._onFetch);
        },

        regions: function() {
            return {
                ListContainer: ".main-list-container"
            };
        },

        _onFetch: function () {
            // Modify url with current collection state
            var path = location.pathname;
            var queryParams = [];

            var search = this.collection.getSearchQuery();
            if (search) {
                queryParams.push('search=' + search);
            }

            var ordering = this.collection.getOrdering();
            if (ordering) {
                queryParams.push('ordering=' + ordering);
            }

            var page = this.collection.getPage();
            if (page > 1) {
                queryParams.push('page=' + page);
            }

            var filters = this.collection.getFilter();
            if (filters) {
                for (var parameter in filters) {
                    if (filters[parameter]) {
                        queryParams.push(parameter + '=' + filters[parameter]);
                    }
                }
            }

            if (queryParams.length) {
                path += ('?' + queryParams.join('&'));
            }

            App.context.changeUrl(path);
        }

    });
});
